import React, { PropTypes } from 'react'

import './Step.scss'

const Step = (props) => {
  const {
    image,
    number,
    title,
    description
  } = props

  return (
    <div className='Step'>
      <div className='Step-image'>
        <img src={image} />
      </div>
      <div className='Step-description'>
        <div className='Step-number'>{number}</div>
        <div className='Step-text'>
          <h4>{title}</h4>
          <p>{description}</p>
        </div>
      </div>
    </div>
  )
}

Step.displayName = 'Step'
Step.propTypes = {
  image: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export default Step



// WEBPACK FOOTER //
// ./src/screens/App/screens/Home/components/Step/Step.js